// ============================================
// Session Service
//
// Rotates sessionId in localStorage on authentication
// state changes to limit XSS exposure window.
// Per hlx-e01-consent-system-v1.md, a new sessionId
// is generated on:
//   1. Anonymous → authenticated upgrade
//   2. Explicit login
//   3. Explicit logout
// ============================================

const STORAGE_KEY = 'hemologix_session_id';

/**
 * Generate a new sessionId using crypto.randomUUID(),
 * remove the old value, and write the new one atomically.
 * Returns the new sessionId.
 */
export function rotateSessionId(): string {
  const newId = `session_${crypto.randomUUID()}`;
  // Remove old before writing new — no window where both exist
  localStorage.removeItem(STORAGE_KEY);
  localStorage.setItem(STORAGE_KEY, newId);
  return newId;
}

/**
 * Called when an anonymous user upgrades to authenticated.
 * Rotates the session to limit the exposure window of the
 * anonymous session token.
 */
export function onAuthUpgrade(): string {
  return rotateSessionId();
}

/**
 * Called on explicit login (returning patient signs in).
 * Rotates session to isolate the new authenticated session.
 */
export function onLogin(): string {
  return rotateSessionId();
}

/**
 * Called on explicit logout.
 * Rotates session so the post-logout anonymous session
 * cannot reuse the authenticated session token.
 */
export function onLogout(): string {
  return rotateSessionId();
}
